"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.formatDate = void 0;

var _RawTextField = _interopRequireDefault(require("./components/RawTextField"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var INVALID_CHARS_REGEX = /[^0-9/]/g;

var removeInvalidChars = function removeInvalidChars(value) {
  return value.replace(INVALID_CHARS_REGEX, '');
};

var MONTH_ONLY_REGEX = /^([0-9]{1,2})(\/?)$/;
var MONTH_AND_DAY_REGEX = /^([0-9]{1,2})\/?([0-9]{1,2})(\/?)$/;
var FULL_DATE_REGEX = /^([0-9]{1,2})\/([0-9]{1,2})\/?([0-9]{1,4})/;

var formatDate = function formatDate(value) {
  var numbers = removeInvalidChars(value);

  if (MONTH_ONLY_REGEX.test(numbers)) {
    var match = MONTH_ONLY_REGEX.exec(numbers);
    var month = match[1];
    var endSlash = match[2];
    return "".concat(endSlash && month.length !== 2 ? "0".concat(month) : month).concat(endSlash);
  } else if (MONTH_AND_DAY_REGEX.test(numbers)) {
    var _match = MONTH_AND_DAY_REGEX.exec(numbers);

    var _month = _match[1];
    var day = _match[2];
    var _endSlash = _match[3];
    return "".concat(_month.length === 2 ? _month : "0".concat(_month), "/").concat(_endSlash && day.length !== 2 ? "0".concat(day) : day).concat(_endSlash);
  } else if (FULL_DATE_REGEX.test(numbers)) {
    var _match2 = FULL_DATE_REGEX.exec(numbers);

    var _month2 = _match2[1];
    var _day = _match2[2];
    var year = _match2[3];
    return "".concat(_month2.length === 2 ? _month2 : "0".concat(_month2), "/").concat(_day.length === 2 ? _day : "0".concat(_day), "/").concat(year);
  }

  return numbers;
};

exports.formatDate = formatDate;

var DateField = function DateField(props) {
  return _react.default.createElement(_RawTextField.default, _extends({}, props, {
    type: "text",
    value: formatDate(props.value),
    onChange: function onChange(value, event) {
      return props.onChange(removeInvalidChars(value), value, event);
    },
    maxLength: 10 // 12/45/7890
    ,
    pattern: "[0-9]*"
  }));
};

DateField.Sizes = _RawTextField.default.Sizes;
DateField.propTypes = (0, _lodash.default)(_RawTextField.default.propTypes, ['type', 'isMultiline']);
DateField.defaultProps = _RawTextField.default.defaultProps;
var _default = DateField;
exports.default = _default;